import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';

export const Route = createFileRoute('/_private/settings/recruiting-statuses/')({
  staticData: { isFullWidth: true },
  validateSearch: filterState.parse,
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={3} />,
});
